/**
 * @Author: v_jppjpeng
 * @Date: 2023-12-18 16:16:42
 * @Explain: Aegis + 系统上报 （埋点功能）
 */

import { API } from '@/config';
import { LogType, PropsType } from './typing';

// https://cloud.tencent.com/document/product/1464/58563
class AegisMonitor {
  /** 上报 用户唯一信息   或随机字符串 */
  uin: PropsType['uin'];

  /** aegis 上报调用api  */
  public aegisApi: PropsType['aegisApi'];

  constructor(options?: { uin?: string }) {
    // 用try 是避免 断网时的代码阻塞
    try {
      // @ts-ignore
      this.aegisApi = new Aegis({
        id: API.aegisId, // 上报 id
        // 可选的随机字段 不存在配置 no-login-info
        uin: options?.uin || 'no-login-info',
        reportApiSpeed: true, // 接口测速
        reportAssetSpeed: true, // 静态资源测速
        spa: true, // spa 应用页面跳转的时候开启 pv 计算
        hostUrl: 'https://rumt-sg.com',
        // url 空 不上报
        // pvUrl: '',
        // whiteListUrl: '',
        // delay: 5000,
        onBeforeRequest: (data: {
          url?: any;
          log?: any[];
          type?: string;
          msg: string;
        }) => {
          try {
            // event 事件处理
            if (data?.log?.length && data.type === 'event') {
              // console.log('data?.log', data?.log);
              // 自定义msg 测试
              let customMsg = '';
              data?.log?.forEach(
                (item: {
                  name: string;
                  msg?: string;
                  ext1?: any;
                  ext2?: any;
                  ext3?: any;
                }) => {
                  if (item?.msg) {
                    // 替换msg
                    customMsg = item.msg;
                  }
                },
              );
              // console.log('customMsg\t', customMsg);
              data.msg = customMsg;
            }
          } catch (e) {
            console.error(e);
          }

          // console.log('腾讯云上报之前 onBeforeRequest\t', data);
          return data;
        },
        beforeReport: (log) => {
          let isNestjs =
            log.msg.indexOf('https://capi.smartlink.intlgame.com/n/api') !==
              -1 ||
            log.msg.indexOf(
              'https://capi-test.smartlink.intlgame.com/n/api',
            ) !== -1;

          if (isNestjs) {
            let statusCode;
            // 提取statusCode
            if (log.level === '8') {
              let match = log.errorMsg.match(/status code (\d+)/);
              statusCode = Number(match ? match[1] : null);
            } else if (log.level === '16') {
              let match = log.msg.match(/status: (\d+)/);
              statusCode = Number(match ? match[1] : null);
            }
            if (
              statusCode &&
              ((statusCode >= 400 && statusCode < 500) ||
                (statusCode >= 200 && statusCode < 300))
            ) {
              // 非错误日志，正常业务逻辑
              return false;
            }
          }

          return log;
        },
        api: {
          apiDetail: true,
          retCodeHandler: function (data: any, url: string, xhr: any) {
            // 注意这里的 data 的数据类型，跟接口返回值的数据类型一致，开发者需要根据实际情况自行处理
            // fetch 请求的时候，data 是 string，如果需要对象需要手动 parse 下
            // xhr 请求的时候，data 是 xhr.response 拿到完整的后台响应
            if (
              url.indexOf('https://capi.smartlink.intlgame.com/n/api') > -1 ||
              url.indexOf('https://capi-test.smartlink.intlgame.com/n/api') > -1
            ) {
              const isErr = !(
                (xhr.status >= 400 && xhr.status < 500) ||
                (xhr.status >= 200 && xhr.status < 300)
              );
              return {
                isErr,
                code: isErr ? xhr.status : 0,
              };
            } else {
              try {
                data = JSON.parse(data);
              } catch (e) {
                console.error(e);
              }
              let code = data?.body.code;
              let isErr = false;
              if (xhr.status !== 200 || code !== 0) {
                isErr = true;
              }
              return {
                isErr,
                code,
              };
            }
          },
        },
      });
    } catch (r) {
      console.error(r);
      // @ts-ignore
      this.aegisApi = null;
    }
  }

  // 配置setConfig
  public setConfig(options: { uin: string }) {
    this.uin = options.uin;
    this.aegisApi?.setConfig?.({
      uin: options.uin,
      // // 配置上报 url
      // pvUrl: 'https://rumt-sg.com/collect/pv',
      // whiteListUrl: 'https://rumt-sg.com/collect/whitelist',
    });
  }

  /** aegis 上报 */
  public reportEvent(params: {
    name: string;
    ext1?: any;
    ext2?: any;
    ext3?: any;
  }) {
    this.aegisApi?.reportEvent?.({
      ...params,
    });
  }

  /** aegis 上报 */
  public infoAll(params: {
    msg: string;
    ext1?: string;
    ext2?: string;
    ext3?: string;
  }) {
    this.aegisApi?.infoAll?.(params);
  }

  // report 默认是 aegis.report 的日志类型，但是现在您可以传入任何日志类型了
  public report(params: {
    msg: '这是一个ajax错误日志';
    level: LogType.AJAX_ERROR[];
    ext1: 'ext1';
    ext2: 'ext2';
    ext3: 'ext3';
    trace: 'trace';
  }) {
    if (!params.level) {
      params.level = [LogType.AJAX_ERROR];
    }
    if (!params.trace) {
      params.trace = 'trace';
    }
    this.aegisApi?.report?.({
      ...params,
    });
  }
  // error 用来表示 JS 错误日志，也是全量上报，一般用于开发者主动获取JS异常，然后进行上报
  public error(params: {
    msg: 'test';
    ext1: any;
    ext2: any;
    ext3: any;
    trace: 'trace';
  }) {
    const newParams = {
      msg: params.msg,
      ext1: JSON.stringify(params.ext1),
      ext2: JSON.stringify(params.ext2),
      ext3: JSON.stringify(params.ext3),
      trace: 'trace',
    };
    this.aegisApi?.error?.({ ...newParams });
  }
}
const aegisMonitor = new AegisMonitor();
export default aegisMonitor;
